import Vue from 'vue';
import Form from '../form/form';

export default function () {
  const personalForms = [].slice.call(document.querySelectorAll('.personalForm'));

  if (personalForms.length !== 0) {
    personalForms.forEach((personal) => {
      new Vue({
        el: personal,
        delimiters: ['${', '}}'],
        components: {
          personalForm: Form(window.formsData.presentation),
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./bali-blocks/personalForm/personalForm.js